/**
 * queryOrderByKey
 *
 * The one construction of a query ordering's `field:direction` identity.
 * `persistCollection` stamps it onto the persist so every snapshot that
 * subscription hands out names the ordering that produced it; ArTable's
 * pagination keys its cursor cache on the same string. The two must agree
 * character for character — `useArTablePaginationCursors` compares them to
 * reject a cursor captured under a superseded ordering (SYD-2304).
 *
 * An absent `orderBy` is not an absence of ordering: Firestore serves such a
 * query ordered by document name ascending, so it keys to a real ordering and
 * never collides with the cursor cache's "never paged" empty-string sentinel.
 */

import type { OrderByOption } from '../Store.types';

function queryOrderByKey(orderBy: OrderByOption | undefined): string {
  return orderBy ? `${orderBy.field}:${orderBy.direction}` : '__name__:asc';
}

export { queryOrderByKey };
